import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { fayettevilleConfig } from "./data";

export default function FayettevilleNCPage() {
  return <CityPageTemplate config={fayettevilleConfig} />;
}